import { Routes } from '@angular/router';
import { CustomerGuard } from '@next/core-lib/relationships';

import { TgaPotatoSeedStarchDashboardComponent } from './tga-potato-seed-starch-dashboard.component';

export const tgaPotatoSeedStarchDashboardRoutes: Routes = [
  {
    path: 'tga-potato-seed-starch-dashboard',
    component: TgaPotatoSeedStarchDashboardComponent,
    canActivate: [CustomerGuard],
  },
];
